import script from "./AiChatCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiChatCard.vue?vue&type=script&setup=true&lang=ts"

import "./AiChatCard.vue?vue&type=style&index=0&id=736a8a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736a8a46"]])

export default __exports__